import { StoreState } from "./index";

export const getExchangeId = (state: StoreState) => state.exchange.exchangeId;

export function getExchanges(
  state: StoreState
): StoreState["exchange"]["exchanges"] {
  return state.exchange.exchanges;
}

export function getIsLoadingExchanges(
  state: StoreState
): StoreState["isLoadingExchanges"] {
  return state.isLoadingExchanges;
}
